export enum AuthFormView {
    login,
    signup,
    forgot,
    reset,
    signup_confirm,
    verify_otp,
    login_provider
}
